import React from 'react';
const useStateRef = (initialState) => {
    const [state, setState] = React.useState(initialState);
    const ref = React.useRef(state);
    const dispatch = React.useCallback((setStateAction) => {
        if (typeof setStateAction === 'function') {
            ref.current = setStateAction(ref.current);
        }
        else {
            ref.current = setStateAction;
        }
        setState(ref.current);
    }, []);
    return [state, dispatch, ref];
};
export default useStateRef;
